import { msrpFormat } from 'shared-code/format'
import SoundLabel from 'shared-components/ui/SoundLabel'
import { BasicStyledComponent, DSBest } from 'shared-definitions/types'
import styles from './BestHeader.module.css'

interface BestHeaderProps extends BasicStyledComponent {
  item: Pick<DSBest, 'headLabel' | 'title' | 'sponsored' | 'msrp'>
}

const BestHeader: React.VFC<BestHeaderProps> = ({ className, item }) => (
  <div className={className}>
    {item.headLabel ? (
      <SoundLabel label={item.headLabel} className={styles.headLabel} />
    ) : (
      <div className={styles.headLabel} />
    )}
    <div className={styles.title}>{item.title}</div>
    {item.msrp ? <div className={styles.subTitle}>{msrpFormat(item.msrp)}</div> : null}
    {item.sponsored ? <div className={styles.promoted}>{'Promoted'}</div> : null}
  </div>
)

export default BestHeader
